import { connect } from 'react-redux'
import Component from './component'

const mapStateToProps = state => {
  const { selectedProgram } = state.reportsManager || {}
  return {
    selectedProgram,
  }
}

export default connect(mapStateToProps)(Component)
